import Vuex from 'vuex';
import HorsePopup from '@/components/parts/HorsePopup.vue';
//import RunnerSelection from './components/RunnerSelection.vue';
import Multiselect from 'vue-multiselect';
import NextRaces from '@/components/parts/NextRaces.vue';
import RaceDetails from '@/components/race/RaceDetails.vue';
import RunnerDetails from './components/RunnerDetails';
import {instance, bettingApi} from "@/api";

import Modal from '@/components/parts/modal';
import Auth from '@/components/auth/Auth';
import moment from 'moment-timezone';
import axios from 'axios';



const CancelToken = axios.CancelToken;
let cancel;

export default {
	name: 'Betslip',
	props: [
		'race'
	],
	components: {
		'horse-popup': HorsePopup,
		'race-details-component': RaceDetails,
		'multiselect': Multiselect,
		'next-races': NextRaces,
		'runner-details': RunnerDetails,
		'modal': Modal,
		'auth-component': Auth
		//'runner-selection': RunnerSelection
	},
	data() {
		return {
			horsePopup: null,
			runnerDetails: null,
			calculation: false,

			//Bet stuff
			/*state: [],*/

			submitModal: {
				active: false,
				state: 'submit', //[ submit, loading, response  ]
				response: {
					state: '',
					message: '',
					betId: null
				}
			},
			settings: {
				hasboxed: false,
				hasx: false,
				hasall: false,
				hasspot: false,
				bettype: null,
				combination: {
					base: [],
					asso: []
				},
				complimentary: null,
				complArray: [
					1,
					2,
					3,
					4,
					5
				],
				stakeAmount: 0,
				stakeFlexi: {
					name: 100,
					label: this.t('racecard.bet.box.flexi.base'),
					$isDisabled: false
				},
				/*stakeAmountArray: [
					1200,
					2400,
					3600,
					4800,
					6000,
					7200,
					8400,
					9600,
					10800,
					12000,
					18000,
					19200,
					20400,
					21600,
					24000,
					30000,
					39600,
					48000,
					60000,
					120000
				],*/
				multiOption: 0,
				betMultiplier: 1,

				//Spot stuff
				spotType: 'unitary', //['unitary', 'combined'],
				spotCombinedOption: 0,
				spotMix: false,

				//Jackpot stuff
				hasjackpot: false

			},
			response: {
				calculated: 0
			},
			line: '',
			//rules: []

		}
	},
	computed: {
		...Vuex.mapState([
			'lang'
		]),
		...Vuex.mapGetters({
			userLogedIn: 'getUserStatus',
		}),
		oneStakeAmount(){
			let flex = this.settings.stakeFlexi.name /100;

			return this.settings.betMultiplier * (this.settings.stakeAmount * flex);
		},
		maxStakeAmount(){

			if(this.settings.stakeFlexi.name !== 100){
				let flex = this.settings.stakeFlexi.name /100;

				return this.settings.stakeAmount * flex;
			}else{
				return this.settings.betMultiplier * this.settings.stakeAmount;
			}

		},
		totalStakeAmount(){
			return this.oneStakeAmount * this.response.calculated
		},
		totalJackpotAmount(){
			return this.totalStakeAmount * this.rule.jackpot_coefficient;
		},
		rules(){
			//return all bet types rules
			return this.$store.state.race.rules;
		},
		rule() {
			let def = {
				maxstake: 100,
				minstake: 100,
				horses: 0,
				maxHorses: 99, //no limit
				complimentary: false,
				associate: false,
				multiOptions: [],
				//Spot stuff
				spotCombinedOptions: [],
				spotMix: false,
				spotInsert: false,

				//Andreas style
				hasboxed: false,
				hasx: false,
				hasall: false,
				hasrepl: false,
				hasspot: false,
				flexi50: false,
				flexi25: false,
				flexi10: false,
				hasjackpot: false,
				jackpot_coefficient: 0.75
			};
			let rt = {};
			let stake = {};

			if (this.settings.bettype) {
				rt = this.rules.find((r) => {
					return r.name === this.settings.bettype.code;
				});

				if (!rt) {
					rt = {};
				}
				stake = {
					maxstake: this.settings.bettype.maxstake,
					minstake: this.settings.bettype.minstake,
				}
			}

			return Object.assign({}, def, rt.param, stake);
		},

		postData(){
			//Trasnspile LNL-PMU to Andreas backend

			let tempString = this.betString.replace(/ -/g, ''); //Clean string for Andreas

			if(this.settings.complimentary){
				tempString += ` CDC : ${this.settings.complimentary}`;
			}

			return {
				race_id: this.race.details.id,
				boxed: this.settings.hasboxed ? '1' : '0',
				bettype: this.settings.bettype.code,
				betString: tempString,
				multiOption: this.settings.multiOption,
				stakeamount: this.oneStakeAmount,
				flexiOption: this.settings.stakeFlexi.name

				/*hasx: this.settings.hasx,
				hasall: this.settings.hasx,
				hasspot: this.settings.hasx,
				complimentary: this.settings.complimentary,
				spotMix: this.settings.spotMix,
				spotCombinedOption: this.settings.spotCombinedOption,
				spotType: this.settings.spotType,
				hasjackpot: this.settings.hasjackpot,*/
			};
		},

		spotCombinedOptions(){
			let arr = this.rule.spotCombinedOptions;

			if(this.settings.multiOption || this.settings.spotMix){
				arr = arr.filter((el) => {
					return el > this.settings.multiOption && el <= this.activeRunnersCount;
				});
			}

			return arr;
		},
		complArray() {
			let arr = [];
			arr.push('');

			if (this.race.details && this.race.details.runners) {
				this.race.details.runners.forEach((el) => {
					if (el.status) {
						arr.push(el.startnr);
					}
				})
			}

			return arr;
		},
		isAssociateMode() {

			return this.rule.hasx && this.settings.hasx /*&& !this.settings.hasall*/;
		},
		baseMaxLength(){
			let count = this.rule.horses;


			if(this.settings.hasjackpot){

				return this.rule.maxHorses;
			}else if(this.settings.multiOption){
				//Just multi
				count = this.settings.multiOption;

				if(this.settings.hasspot && this.settings.spotType === 'combined'){

					// Multi + spOt Combined
					count = this.settings.multiOption > this.settings.spotCombinedOption ? this.settings.multiOption : this.settings.spotCombinedOption;
				}

			}else if(this.settings.hasspot && this.settings.spotType === 'combined'){

				//Only spot-combined
				count = this.settings.spotCombinedOption;
			}



			return count;
		},
		emptyCount() {

			let count = this.baseMaxLength - this.settings.combination.base.length;
			if (count < 0) {
				count = 0;
			}
			return count;
		},
		activeRunnersCount() {
			let count = 0;

			if (this.race) {
				this.race.details.runners.forEach((runner) => {
					if (runner.status) {
						count++;
					}
				});
			}


			return count;
		},

		/**
		 * @computed parameter - Define if more base horses could be selected
		 * return Boolean
		 * */
		moreBasePositions() {
			let length = this.rule.horses;

			if (this.settings.multiOption > 0) {
				length = this.settings.multiOption;
			}

			if(this.settings.hasspot && !this.settings.spotMix){
				return false;
			}else{
				return this.settings.combination['base'].length < length;
			}


		},
		moreStrictBase(){
			return this.baseMaxLength - this.settings.combination.base.length;
		},
		isSpotInBet(){
			return 	this.settings.combination.base.some((el)=> el.startnr === '?');
		},
		/**
		 * @computed parameter - Define if more overall horses could be selected
		 * return Boolean
		 * */
		morePositions() {
			//Return boolean of overall available positions
			return (this.settings.combination['base'].length + this.settings.combination['asso'].length) <= this.activeRunnersCount
		},




		raceTimeText() {
			if (this.race.details) {
				return moment(this.race.details.time).format('H[h]mm')
			}
		},
		betString() {
			let legstring = '';

			if(this.rule.hasspot && this.settings.hasspot){
				//Calculation for SPOT bet types
				if(!this.settings.spotMix){
					//Calculate fully automatic betstring

					//Clear previous betstring
					this.settings.combination.base = [];

					//Push spots
					for(let i = 0; i<this.baseMaxLength; i++){
						this.pushCombination(i+'?', '?', 'base');
						legstring+= '? - ';
					}
				}else{

					for(let i = 0; i<this.baseMaxLength; i++){
						if(i<this.settings.combination.base.length){
							legstring+= this.settings.combination.base[i].startnr + ' - ';
						}else{
							legstring+= '? - ';
						}

					}
				}

			}else{
				//Calculation for all non spot bettypes

				for (let cb of this.settings.combination.base) {
					legstring += cb.startnr + ' - ';
				}
				if (this.settings.combination.asso.length) {
					legstring += "R - ";
					for (let ca of this.settings.combination.asso) {
						legstring += ca.startnr + ' - ';
					}
				}
			}

			legstring = legstring.trim();
			if(legstring.charAt(legstring.length - 1) === '-'){
				legstring = legstring.substr(0, legstring.length - 1);
				legstring = legstring.trim();
			}
			return legstring;
		},
		isSpotCheck(){

			//Only if spot available and active, and spotMix selected.

			if(this.rule.hasspot && this.settings.hasspot){
				return this.settings.spotMix
			}

			return true;
		},
		isSpotStrict(){
			return this.rule.hasspot && this.settings.hasspot && this.settings.spotMix;
		},

		haveMinimum(){
			//Spot need to be calculated all time, easier to implement
			return this.settings.hasspot || ((this.settings.combination['base'].length + this.settings.combination['asso'].length) >=  this.rule.horses);
		},

		isValidBet(){

			return this.isBettingActive && this.haveMinimum && this.response.calculated > 0 && this.maxStakeAmount <= this.rule.maxstake;
		},
		flexiList(){
			let list = [{
				name: 100,
				label: this.t('racecard.bet.box.flexi.base'),
				$isDisabled: false
			}];

			if(this.rule.flexi50){
				list.push({
					name: 50,
					label: this.t('racecard.bet.box.flexi.50'),
					$isDisabled: this.isFlexiDisabled(50)
				});
			}
			if(this.rule.flexi25){
				list.push({
					name: 25,
					label: this.t('racecard.bet.box.flexi.25'),
					$isDisabled: this.isFlexiDisabled(25)
				});
			}
			if(this.rule.flexi10){
				list.push({
					name: 10,
					label: this.t('racecard.bet.box.flexi.10'),
					$isDisabled: this.isFlexiDisabled(10)
				});
			}

			return list;
		},
		multiplierList(){
			if(this.settings.hasspot){
				return [1,2,3,4,5,6,7,8,9,10];
			}else{
				return [1,2,3,4,5,10,15,20,50,80];
			}

		},
		isBettingActive(){
			return this.race.details.status === 'OPEN';
		},
		favorite(){
			let fav = {
				id: null,
				odd: null
			};

			this.race.details.runners.forEach(runner => {
				let { id, odd } = runner;
				if(
					(odd !== null && fav.odd === null) ||
					(odd !== null && odd < fav.odd)
				){
					fav = { id, odd };
				}
			});
			return fav;
		}

	},
	watch: {
		/*'$route' (to, from) {
			// обработка изменений параметров пути...
			//console.log(to);
		},*/

		//Base combination changed
		'settings.combination.base': function (value) {

			//Recalculate main horses
			this.markMain(value);
		},
		/*'settings.combination.asso': function (value) {

			if(this.settings.hasx && this.rule.hasall){
				let count = 0;

				for (let runner of this.race.details.runners) {
					if (runner.status && !this.inComb(runner.id, 'asso') && !this.inComb(runner.id, 'base')) {
						count++;
					}
				}
				if(count > 0){
					this.settings.hasall = true;
				}
			}


		},*/

		'settings.stakeFlexi': function (val) {
			if(val.name !== 100){
				this.settings.betMultiplier = 1;
			}
		},

		'settings.bettype': function () {
			//If bettype changes, then clear betslip
			this.setDefaults();

			this.settings.hasjackpot = this.rule.hasjackpot;

		},
		'settings.hasx': function (value) {
			if (value && this.rule.hasx) {

				//Reduce already existing combination of base runners
				this.settings.combination.base = this.settings.combination.base.slice(0, this.rule.horses - 1);

				this.removeCombination('x', 'base');
				if (this.settings.combination.base.length > 0) {
					this.pushCombination('x', 'X', 'base');
				}
			} else {
				this.removeCombination('x', 'base');
				this.settings.hasall = false;
			}
		},
		'settings.hasall': function (value) {
			if (value) {

				//Add to combination all runners
				for (let runner of this.race.details.runners) {
					if (runner.status && runner.startnr < 100 && !this.inComb(runner.id, 'asso') && !this.inComb(runner.id, 'base')) {
						this.pushCombination(runner.id, runner.startnr, 'asso');
					}
				}
				//this.removeCombination('x', 'base');

			} else if (!value && this.settings.hasx) {

				//Reduce base combination to be able select associate combination
				this.settings.combination.base = this.settings.combination.base.slice(0, this.rule.horses)
			}
		},
		'rule.multiOptions': function (val) {
			if(val.length > 0){
				this.settings.multiOption = this.rule.multiOptions[0];
			}
		},
		'settings.multiOption': function (val) {
			//Handle multi horses setup and two way changing

			this.markMain(this.settings.combination['base']);


			//Change spot type to unitary if multy is bigger than spotCombine
			if(this.settings.hasspot && this.settings.spotType === 'combined' && val > this.settings.spotCombinedOption){
				this.settings.spotType = 'unitary';
			}
		},
		'settings.complimentary': function (value) {
			if (value !== null || value === '') {
				let item = this.settings.combination['base'].find((el) => el.startnr === value);

				if (item) {
					this.removeCombination(item.id, 'base');
				}
			}
		},
		'settings.spotType': function(value){

			//Settings adjustment for spOt COMBINED
			if(value !== null && value === 'combined' && this.spotCombinedOptions){
				this.settings.spotCombinedOption = this.spotCombinedOptions[0];
			}else{
				this.settings.spotCombinedOption = 0;
			}


			//
			if(this.settings.hasspot && value === 'unitary'){
				//Clear combinations
				this.settings.combination.base = [];
			}

		},
		'settings.hasspot': function(val){
			/*if(val){
				//Clear settings except spot to prevent deadLoop
				this.setDefaults('spot');
			}else{
				this.setDefaults();
			}*/
			this.setDefaults( val ? 'spot' : '' );
		},
		'settings.hasjackpot': function(val){
			if(val){
				this.setDefaults('jackpot');
			}
		},
		'settings.spotMix': function(val){
			this.settings.combination.base = [];

			let last = this.spotCombinedOptions[this.spotCombinedOptions.length - 1];
			if(val && this.settings.spotCombinedOption > last){
				this.settings.spotCombinedOption = last;
			}
		},
		isAssociateMode(value) {
			if (!value) {
				this.settings.combination.asso = [];
			}
		},
		rule(value) {
			this.settings.stakeAmount = value.minstake;
		},
		settings:{
			deep: true,
			handler(){
				this.response.calculated = 0;
				if(this.haveMinimum && this.settings.bettype !== null && this.isBettingActive){

					this.getCombinations();
				}else{
					//Cancel "last call" to be sure that server wont return us any "old" state
					if(typeof cancel ==='function'){
						cancel('recalculate: cancel old one');
						this.calculation = false;
					}
				}


			}
		}
		/*state: {
			deep: true,
			handler(el){
				console.log(el);
			}
		}*/
	},
	mounted() {


		//window.bs=this; //TODO: remove from prod

	},
	methods: {


		insertSpot(){

			if(this.baseMaxLength > this.settings.combination.base.length){
				this.pushCombination((this.settings.combination.base.length-1)+'?', '?', 'base');
			}

		},
		insertX(){

			if(this.baseMaxLength > this.settings.combination.base.length){
				this.pushCombination((this.settings.combination.base.length-1)+'X', 'X', 'base');
			}

		},

		toggleDetails(id){
			if(this.runnerDetails !== id){
				this.runnerDetails = id;
			}else{
				this.runnerDetails = null;
			}
		},
		markMain(combination) {

			//Get a max horse amount
			let length = this.rule.horses;

			//If multi option available for this rule
			if (this.settings.multiOption > 0 && this.rule.multiOptions.length > 0) {
				//Then use selected value
				length = this.settings.multiOption;
			}

			combination.forEach((el, index) => {

				el.isBase = index < length;
			})
		},
		setDefaults(exept) {

			//Clear base combination
			this.settings.combination.base = [];
			//Clean associate combination
			this.settings.combination.asso = [];
			this.response.calculated = 0;
			this.settings.associateMode = false;
			this.settings.hasx = false;
			this.settings.hasall = false;
			this.settings.hasboxed = false;
			this.settings.betMultiplier = 1;
			this.settings.stakeFlexi = {
				name: 100,
				label: this.t('racecard.bet.box.flexi.base'),
				$isDisabled: false
			};
			if(exept !== 'spot'){
				this.settings.hasspot = false;
			}

			if(this.rule.multiOptions.length > 0){
				this.settings.multiOption = this.rule.multiOptions[0];
			}else{
				this.settings.multiOption = 0;
			}

			this.settings.complimentary = null;

			//Spot stuff
			this.settings.spotType = 'unitary';
			this.settings.spotCombinedOption = 0;
			this.settings.spotMix = false;

			//Jackpot stuff
			if(exept !== 'jackpot'){
				if(exept === 'spot' && !this.rule.hasspot){
					this.settings.hasjackpot = false;
				}

			}


		},
		combinationChanged(id, str, type) {

			let opposite = type === 'base' ? 'asso' : 'base';

			if(this.settings.bettype === null || !this.isBettingActive){
				return;
			}


			//Check if runner already in combination
			if (!this.inComb(id, type)  && this.settings.bettype) {

				if(this.isAssociateMode){
					//Associate mode behaviour: Couple/Trio etc

					if (type === 'base' && this.moreBasePositions
						||
						type === 'asso' && this.morePositions
					) {

						if(this.settings.hasx && type === 'base' && this.moreStrictBase === 1 && !this.settings.combination.base.some((el)=> el.startnr === 'X' )){
							return false;
						}
						//Strict combination list
						this.pushCombination(id, str, type);


						//Remove from oposite combination array id if we try add it to current, to keep uniq final value
						this.removeCombination(id, opposite);
					}

				}else{

					if(!this.settings.hasspot && !this.settings.spotMix && !this.settings.hasjackpot){
						//General list behaviour - NO "Associate mode"
						this.pushCombination(id, str, type);

					}else if( this.moreStrictBase > 0 && this.settings.hasjackpot){

						//jackpot behaviour
						this.pushCombination(id, str, type);

					}else if( this.moreStrictBase > 0 && this.settings.spotMix){

						//spOt behaviour
						if( !(!this.isSpotInBet && this.moreStrictBase < 2) ){
							this.pushCombination(id, str, type);
						}

					}
				}

				//It we reselect as main already complimentary horse, then we make it main back, and clear complimentary
				if (type === 'base' && this.settings.complimentary === str) {
					this.settings.complimentary = null;
				}


			} else {
				//Remove from combination
				this.removeCombination(id, type);
			}
		},

		pushCombination(id, starterNr, type) {
			// @type - combination list: 'base' or 'asso'(associate)
			this.settings.combination[type].push({
				id: id,
				startnr: starterNr,
				isBase: false // Default false, will recalc afterwards
			});
		},
		removeCombination(id, type) {
			this.settings.combination[type] = this.settings.combination[type].filter((el) => {
				return el.id.toString() !== id.toString();
			});
		},
		combinationOrder(id, type){
			let ord = null;

			for(let i = 0; i<this.settings.combination[type].length; i++){
				if(this.settings.combination[type][i].id === id){
					ord = i + 1;
					break;
				}
			}
			return ord;

		},


		horseInfo(runner) {
			this.horsePopup = runner;
		},
		hideHorseInfo() {
			this.horsePopup = null;
		},

		isActiveBet(bet) {

			return this.settings.bettype && (bet.code === this.settings.bettype.code);


		},
		runnersCheckClasses(id, type) {
			let arr = [];
			//{'checked': inComb(runner.id, 'base'), 'disabled': !settings.bettype, 'disabled': !inComb(runner.id, 'base') && !moreBasePositionsDisabled}
			let strictMode = this.isAssociateMode;

			if (this.inComb(id, type)) {
				arr.push('checked');
			}else{
				if (   !this.isBettingActive
					|| !this.settings.bettype
					|| ( this.rule.hasspot && this.settings.hasspot && !this.settings.spotMix && type === 'base')
					|| ( this.settings.hasjackpot && this.moreStrictBase < 1)
					|| ( this.isSpotStrict && (this.moreStrictBase < 1 || (this.moreStrictBase === 1 && !this.isSpotInBet)) && type === 'base')
					|| ( strictMode && !this.moreBasePositions && type === 'base')
					|| ( strictMode && !this.morePositions && type === 'asso')
				) {
					arr.push('disabled');
				}

			}




			return arr;
		},
		inComb(id, type) {
			return this.settings.combination[type].some(el => el.id === id);
		},





		spotCombinedOptionCustomLabel(el){
			return `${el} ch`
		},

		stakeTypeLabel(el){
			if(el === 100){
				return this.t('racecard.bet.box.flexi.base');
			}else{
				return this.t('racecard.bet.box.flexi.'+el);
			}
		},
		isFlexiDisabled(rate){
			return this.rule.minstake > this.response.calculated * this.settings.betMultiplier * (this.settings.stakeAmount * (rate/100))
		},

		getCombinations(){

			//Cancel previous requests to keep UI synchronous
			if(typeof cancel ==='function'){
				cancel('recalculate_cancel_previous');
			}
			this.calculation = true;
			return instance.post(bettingApi.calculate, this.postData, {
				cancelToken: new CancelToken(function executor(c) {
					cancel = c;
				})
			}).then((response)=>{
				//console.log(response);
				this.response.calculated = 0;
				if(response.data && response.data.content && typeof response.data.content.combinations !== 'undefined'){
					this.response.calculated = response.data.content.combinations;
				}
				this.calculation = false;
				return response;
			}).catch((er)=>{

				if (axios.isCancel(er)) {
					//console.log(er.message);
				} else {
					console.warn(er);
				}
			});
		},

		startSubmit(){

			if(this.isValidBet){
				this.submitModal.active = true;
				this.submitModal.state = 'loading';
				this.addLoad( 'getCombinationsBefore');
				this.getCombinations().then(()=>{
					this.endLoad('getCombinationsBefore');
					this.$nextTick(()=>{
						if(this.response.calculated > 0 && this.isValidBet){
							this.submitModal.state = 'submit';

						}else {
							this.submitModal.state = 'response';
							this.submitModal.response.state = 'ERROR';
							this.submitModal.response.message = this.t('popup.race.bet_submit.response.no-valid-bets')
						}

					});

				});
			}


		},
		cancelSubmit(){
			this.submitModal.active = false;
			this.submitModal.state = 'submit';

			//Clear response
			this.submitModal.response.state = '';
			this.submitModal.response.message = '';
			this.submitModal.response.betId = null;
		},
		submitModalClose(){
			if(this.submitModal.state !== 'loading'){
				this.cancelSubmit();
			}
		},

		postBet(){
			//Set loading view
			this.submitModal.state = 'loading';
			this.$store.commit('addLoad', 'postBet');

			instance.post(bettingApi.send, this.postData).then((response)=>{
				//console.log(response);
				if(response.data ){

					if(typeof response.data.error === 'undefined'){

						//Normal workflow
						this.submitModal.response.state = response.data.status;
						if(response.data.message){
							this.submitModal.response.message = response.data.message.replace(/_\((.*?)\)$/, '$1');
						}

						if(response.data.status === 'SUCCESS' && response.data.content && response.data.content.betId){
							this.submitModal.response.betId = response.data.content.betId;
							this.setDefaults();
						}
					}else{
						//General error
						this.submitModal.response.state = 'ERROR';
						this.submitModal.response.message = response.data.error.message.replace(/_\((.*?)\)$/, '$1');
					}



				}
			}).catch((er)=>{
				console.warn(er);
			}).then(()=>{

				//Finish loading
				this.submitModal.state = 'response';
				if(this.submitModal.response.message === ''){
					this.submitModal.response.message = '500'
				}
				this.$store.commit('endLoad', 'postBet');
			});
		}


	}
}
